// import { gsap } from "gsap/gsap-core";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

/* global gsap, ScrollTrigger: false */

var _gsScope =
	"undefined" != typeof module && module.exports && "undefined" != typeof global
		? global
		: window;
!(function (_) {
	"use strict";
	function e(_) {
		return u.getComputedStyle(_);
	}
	function t(_, t, $, i) {
		var n;
		return (
			($ = $ || e(_))
				? (n =
						(_ = $.getPropertyValue(t.replace(c, "-$1").toLowerCase())) ||
						$.length
							? _
							: $[t])
				: _.currentStyle && (n = ($ = _.currentStyle)[t]),
			i ? n : parseInt(n, 10) || 0
		);
	}
	function $(_) {
		return !!(
			_.length &&
			_[0] &&
			((_[0].nodeType && _[0].style && !_.nodeType) || (_[0].length && _[0][0]))
		);
	}
	function i(_, e) {
		for (var t, $ = e.length; -1 < --$; )
			if (((t = e[$]), _.substr(0, t.length) === t)) return t.length;
	}
	function n(_) {
		return (
			((_.charCodeAt(0) - 55296) << 10) + (_.charCodeAt(1) - 56320) + 65536
		);
	}
	function r(_, e) {
		var t = -1 !== (_ = _ || "").indexOf("++"),
			$ = 1;
		return (
			t && (_ = _.split("++").join("")),
			function () {
				return "<" + e + x + (_ ? " class='" + _ + (t ? $++ : "") + "'>" : ">");
			}
		);
	}
	function o(_, e) {
		for (var t = e.length; -1 < --t; ) _.push(e[t]);
	}
	function s(_) {
		for (var e = [], t = _.length, $ = 0; $ !== t; e.push(_[$++]));
		return e;
	}
	function l(_, e, t) {
		for (var $; _ && _ !== e; ) {
			if (($ = _._next || _.nextSibling)) return $.textContent.charAt(0) === t;
			_ = _.parentNode || _._parent;
		}
		return !1;
	}
	var a = _.GreenSockGlobals || _,
		d = (function (_) {
			for (var e = _.split("."), t = a, $ = 0; $ < e.length; $++)
				t[e[$]] = t = t[e[$]] || {};
			return t;
		})("com.greensock.utils"),
		h = String.fromCharCode(
			103,
			114,
			101,
			101,
			110,
			115,
			111,
			99,
			107,
			46,
			99,
			111,
			109
		),
		p =
			(String.fromCharCode(
				47,
				114,
				101,
				113,
				117,
				105,
				114,
				101,
				115,
				45,
				109,
				101,
				109,
				98,
				101,
				114,
				115,
				104,
				105,
				112,
				47
			),
			(function (e) {
				for (
					var t =
							-1 !==
								(_ ? _.location.href : "").indexOf(
									String.fromCharCode(
										103,
										114,
										101,
										101,
										110,
										115,
										111,
										99,
										107
									)
								) &&
							-1 !==
								e.indexOf(
									String.fromCharCode(108, 111, 99, 97, 108, 104, 111, 115, 116)
								),
						$ = [
							h,
							String.fromCharCode(
								99,
								111,
								100,
								101,
								112,
								101,
								110,
								46,
								105,
								111
							),
							String.fromCharCode(
								99,
								111,
								100,
								101,
								112,
								101,
								110,
								46,
								112,
								108,
								117,
								109,
								98,
								105,
								110,
								103
							),
							String.fromCharCode(
								99,
								111,
								100,
								101,
								112,
								101,
								110,
								46,
								100,
								101,
								118
							),
							String.fromCharCode(
								99,
								111,
								100,
								101,
								112,
								101,
								110,
								46,
								97,
								112,
								112
							),
							String.fromCharCode(
								112,
								101,
								110,
								115,
								46,
								99,
								108,
								111,
								117,
								100
							),
							String.fromCharCode(112, 101, 110, 115, 46, 105, 111),
							String.fromCharCode(
								109,
								111,
								116,
								105,
								111,
								110,
								116,
								114,
								105,
								99,
								107,
								115,
								46,
								99,
								111,
								109
							),
							String.fromCharCode(
								99,
								115,
								115,
								45,
								116,
								114,
								105,
								99,
								107,
								115,
								46,
								99,
								111,
								109
							),
							String.fromCharCode(99, 100, 112, 110, 46, 105, 111),
							String.fromCharCode(103, 97, 110, 110, 111, 110, 46, 116, 118),
							String.fromCharCode(
								99,
								111,
								100,
								101,
								99,
								97,
								110,
								121,
								111,
								110,
								46,
								110,
								101,
								116
							),
							String.fromCharCode(
								116,
								104,
								101,
								109,
								101,
								102,
								111,
								114,
								101,
								115,
								116,
								46,
								110,
								101,
								116
							),
							String.fromCharCode(
								99,
								101,
								114,
								101,
								98,
								114,
								97,
								120,
								46,
								99,
								111,
								46,
								117,
								107
							),
							String.fromCharCode(
								116,
								121,
								109,
								112,
								97,
								110,
								117,
								115,
								46,
								110,
								101,
								116
							),
							String.fromCharCode(
								116,
								119,
								101,
								101,
								110,
								109,
								97,
								120,
								46,
								99,
								111,
								109
							),
							String.fromCharCode(
								116,
								119,
								101,
								101,
								110,
								108,
								105,
								116,
								101,
								46,
								99,
								111,
								109
							),
							String.fromCharCode(112, 108, 110, 107, 114, 46, 99, 111),
							String.fromCharCode(
								104,
								111,
								116,
								106,
								97,
								114,
								46,
								99,
								111,
								109
							),
							String.fromCharCode(
								119,
								101,
								98,
								112,
								97,
								99,
								107,
								98,
								105,
								110,
								46,
								99,
								111,
								109
							),
							String.fromCharCode(
								97,
								114,
								99,
								104,
								105,
								118,
								101,
								46,
								111,
								114,
								103
							),
							String.fromCharCode(
								99,
								111,
								100,
								101,
								115,
								97,
								110,
								100,
								98,
								111,
								120,
								46,
								105,
								111
							),
							String.fromCharCode(
								115,
								116,
								97,
								99,
								107,
								98,
								108,
								105,
								116,
								122,
								46,
								99,
								111,
								109
							),
							String.fromCharCode(99, 111, 100, 105, 101, 114, 46, 105, 111),
							String.fromCharCode(
								106,
								115,
								102,
								105,
								100,
								100,
								108,
								101,
								46,
								110,
								101,
								116
							),
						],
						i = $.length;
					-1 < --i;

				)
					if (-1 !== e.indexOf($[i])) return !0;
				t &&
					_ &&
					_.console &&
					console.log(
						String.fromCharCode(
							87,
							65,
							82,
							78,
							73,
							78,
							71,
							58,
							32,
							97,
							32,
							115,
							112,
							101,
							99,
							105,
							97,
							108,
							32,
							118,
							101,
							114,
							115,
							105,
							111,
							110,
							32,
							111,
							102,
							32
						) +
							"SplitText" +
							String.fromCharCode(
								32,
								105,
								115,
								32,
								114,
								117,
								110,
								110,
								105,
								110,
								103,
								32,
								108,
								111,
								99,
								97,
								108,
								108,
								121,
								44,
								32,
								98,
								117,
								116,
								32,
								105,
								116,
								32,
								119,
								105,
								108,
								108,
								32,
								110,
								111,
								116,
								32,
								119,
								111,
								114,
								107,
								32,
								111,
								110,
								32,
								97,
								32,
								108,
								105,
								118,
								101,
								32,
								100,
								111,
								109,
								97,
								105,
								110,
								32,
								98,
								101,
								99,
								97,
								117,
								115,
								101,
								32,
								105,
								116,
								32,
								105,
								115,
								32,
								97,
								32,
								109,
								101,
								109,
								98,
								101,
								114,
								115,
								104,
								105,
								112,
								32,
								98,
								101,
								110,
								101,
								102,
								105,
								116,
								32,
								111,
								102,
								32,
								67,
								108,
								117,
								98,
								32,
								71,
								114,
								101,
								101,
								110,
								83,
								111,
								99,
								107,
								46,
								32,
								80,
								108,
								101,
								97,
								115,
								101,
								32,
								115,
								105,
								103,
								110,
								32,
								117,
								112,
								32,
								97,
								116,
								32,
								104,
								116,
								116,
								112,
								58,
								47,
								47,
								103,
								114,
								101,
								101,
								110,
								115,
								111,
								99,
								107,
								46,
								99,
								111,
								109,
								47,
								99,
								108,
								117,
								98,
								47,
								32,
								97,
								110,
								100,
								32,
								116,
								104,
								101,
								110,
								32,
								100,
								111,
								119,
								110,
								108,
								111,
								97,
								100,
								32,
								116,
								104,
								101,
								32,
								39,
								114,
								101,
								97,
								108,
								39,
								32,
								118,
								101,
								114,
								115,
								105,
								111,
								110,
								32,
								102,
								114,
								111,
								109,
								32,
								121,
								111,
								117,
								114,
								32,
								71,
								114,
								101,
								101,
								110,
								83,
								111,
								99,
								107,
								32,
								97,
								99,
								99,
								111,
								117,
								110,
								116,
								32,
								119,
								104,
								105,
								99,
								104,
								32,
								104,
								97,
								115,
								32,
								110,
								111,
								32,
								115,
								117,
								99,
								104,
								32,
								108,
								105,
								109,
								105,
								116,
								97,
								116,
								105,
								111,
								110,
								115,
								46,
								32,
								84,
								104,
								101,
								32,
								102,
								105,
								108,
								101,
								32,
								121,
								111,
								117,
								39,
								114,
								101,
								32,
								117,
								115,
								105,
								110,
								103,
								32,
								119,
								97,
								115,
								32,
								108,
								105,
								107,
								101,
								108,
								121,
								32,
								100,
								111,
								119,
								110,
								108,
								111,
								97,
								100,
								101,
								100,
								32,
								102,
								114,
								111,
								109,
								32,
								101,
								108,
								115,
								101,
								119,
								104,
								101,
								114,
								101,
								32,
								111,
								110,
								32,
								116,
								104,
								101,
								32,
								119,
								101,
								98,
								32,
								97,
								110,
								100,
								32,
								105,
								115,
								32,
								114,
								101,
								115,
								116,
								114,
								105,
								99,
								116,
								101,
								100,
								32,
								116,
								111,
								32,
								108,
								111,
								99,
								97,
								108,
								32,
								117,
								115,
								101,
								32,
								111,
								114,
								32,
								111,
								110,
								32,
								115,
								105,
								116,
								101,
								115,
								32,
								108,
								105,
								107,
								101,
								32,
								99,
								111,
								100,
								101,
								112,
								101,
								110,
								46,
								105,
								111,
								46
							)
					);
			})(_ ? _.location.host : ""),
			function (_) {
				var e = _.nodeType,
					t = "";
				if (1 === e || 9 === e || 11 === e) {
					if ("string" == typeof _.textContent) return _.textContent;
					for (_ = _.firstChild; _; _ = _.nextSibling) t += p(_);
				} else if (3 === e || 4 === e) return _.nodeValue;
				return t;
			}),
		f = document,
		u =
			void 0 !== _ ? _ : f.defaultView || { getComputedStyle: function () {} },
		c = /([A-Z])/g,
		C = /(?:\r|\n|\t\t)/g,
		g = /(?:\s\s+)/g,
		x =
			" style='position:relative;display:inline-block;" +
			(f.all && !f.addEventListener ? "*display:inline;*zoom:1;'" : "'"),
		y =
			(d.SplitText =
			a.SplitText =
				function (_, e) {
					if (!_) throw "cannot split a null element.";
					(this.elements = $(_)
						? (function (_) {
								for (var e, t, i = [], n = _.length, r = 0; r < n; r++)
									if ($((e = _[r])))
										for (t = e.length, t = 0; t < e.length; t++) i.push(e[t]);
									else i.push(e);
								return i;
						  })(_)
						: [_]),
						(this.chars = []),
						(this.words = []),
						(this.lines = []),
						(this._originals = []),
						(this.vars = e || {}),
						this.split(e);
				}),
		m = function (_, e, t) {
			var $ = _.nodeType;
			if (1 === $ || 9 === $ || 11 === $)
				for (_ = _.firstChild; _; _ = _.nextSibling) m(_, e, t);
			else (3 !== $ && 4 !== $) || (_.nodeValue = _.nodeValue.split(e).join(t));
		},
		v = function (_) {
			for (var e, t = s(_.childNodes), $ = t.length, i = 0; i < $; i++)
				(e = t[i])._isSplit
					? v(e)
					: (i && 3 === e.previousSibling.nodeType
							? (e.previousSibling.nodeValue +=
									3 === e.nodeType ? e.nodeValue : e.firstChild.nodeValue)
							: 3 !== e.nodeType && _.insertBefore(e.firstChild, e),
					  _.removeChild(e));
		},
		S = function (_, e, $, r) {
			var o,
				l,
				a = s(_.childNodes),
				d = a.length,
				h = "absolute" === e.position || !0 === e.absolute;
			if (3 !== _.nodeType || 1 < d) {
				for (e.absolute = !1, o = 0; o < d; o++)
					(3 !== (l = a[o]).nodeType || /\S+/.test(l.nodeValue)) &&
						(h &&
							3 !== l.nodeType &&
							"inline" === t(l, "display", null, !0) &&
							((l.style.display = "inline-block"),
							(l.style.position = "relative")),
						(l._isSplit = !0),
						S(l, e, $, r));
				return (e.absolute = h), void (_._isSplit = !0);
			}
			!(function (_, e, t, $) {
				var r,
					o,
					s,
					l,
					a,
					d,
					h,
					u,
					c,
					x,
					y = e.tag ? e.tag : e.span ? "span" : "div",
					v =
						-1 !== (e.type || e.split || "chars,words,lines").indexOf("chars"),
					S = "absolute" === e.position || !0 === e.absolute,
					b = e.wordDelimiter || " ",
					T = " " !== b ? "" : S ? "&#173; " : " ",
					N = "</" + y + ">",
					w = !0,
					A = e.specialChars
						? "function" == typeof e.specialChars
							? e.specialChars
							: i
						: null,
					L = f.createElement("div"),
					B = _.parentNode;
				for (
					B.insertBefore(L, _),
						L.textContent = _.nodeValue,
						B.removeChild(_),
						h = -1 !== (r = p((_ = L))).indexOf("<"),
						!1 !== e.reduceWhiteSpace && (r = r.replace(g, " ").replace(C, "")),
						h && (r = r.split("<").join("{{LT}}")),
						a = r.length,
						o = (" " === r.charAt(0) ? T : "") + t(),
						s = 0;
					s < a;
					s++
				)
					if (((d = r.charAt(s)), A && (x = A(r.substr(s), e.specialChars))))
						(d = r.substr(s, x || 1)),
							(o += v && " " !== d ? $() + d + "</" + y + ">" : d),
							(s += x - 1);
					else if (d === b && r.charAt(s - 1) !== b && s) {
						for (o += w ? N : "", w = !1; r.charAt(s + 1) === b; )
							(o += T), s++;
						s === a - 1
							? (o += T)
							: ")" !== r.charAt(s + 1) && ((o += T + t()), (w = !0));
					} else
						"{" === d && "{{LT}}" === r.substr(s, 6)
							? ((o += v ? $() + "{{LT}}</" + y + ">" : "{{LT}}"), (s += 5))
							: (55296 <= d.charCodeAt(0) && 56319 >= d.charCodeAt(0)) ||
							  (65024 <= r.charCodeAt(s + 1) && 65039 >= r.charCodeAt(s + 1))
							? ((u = n(r.substr(s, 2))),
							  (c = n(r.substr(s + 2, 2))),
							  (l =
									(127462 <= u && u <= 127487 && 127462 <= c && c <= 127487) ||
									(127995 <= c && c <= 127999)
										? 4
										: 2),
							  (o +=
									v && " " !== d
										? $() + r.substr(s, l) + "</" + y + ">"
										: r.substr(s, l)),
							  (s += l - 1))
							: (o += v && " " !== d ? $() + d + "</" + y + ">" : d);
				(_.outerHTML = o + (w ? N : "")), h && m(B, "{{LT}}", "<");
			})(_, e, $, r);
		},
		b = y.prototype;
	(b.split = function (_) {
		this.isSplit && this.revert(),
			(this.vars = _ = _ || this.vars),
			(this._originals.length =
				this.chars.length =
				this.words.length =
				this.lines.length =
					0);
		for (
			var $,
				i,
				n,
				s = this.elements.length,
				a = _.tag ? _.tag : _.span ? "span" : "div",
				d = r(_.wordsClass, a),
				h = r(_.charsClass, a);
			-1 < --s;

		)
			(n = this.elements[s]),
				(this._originals[s] = n.innerHTML),
				($ = n.clientHeight),
				(i = n.clientWidth),
				S(n, _, d, h),
				(function (_, $, i, n, r, s, a) {
					var d,
						h,
						p,
						u,
						c,
						C,
						g,
						x,
						y,
						S,
						b,
						T,
						N = e(_),
						w = t(_, "paddingLeft", N),
						A = -999,
						L = t(_, "borderBottomWidth", N) + t(_, "borderTopWidth", N),
						B = t(_, "borderLeftWidth", N) + t(_, "borderRightWidth", N),
						O = t(_, "paddingTop", N) + t(_, "paddingBottom", N),
						V = t(_, "paddingLeft", N) + t(_, "paddingRight", N),
						W = 0.2 * t(_, "fontSize"),
						H = t(_, "textAlign", N, !0),
						E = [],
						k = [],
						R = [],
						j = $.wordDelimiter || " ",
						M = $.tag ? $.tag : $.span ? "span" : "div",
						G = $.type || $.split || "chars,words,lines",
						q = r && -1 !== G.indexOf("lines") ? [] : null,
						z = -1 !== G.indexOf("words"),
						D = -1 !== G.indexOf("chars"),
						F = "absolute" === $.position || !0 === $.absolute,
						P = $.linesClass,
						Q = -1 !== (P || "").indexOf("++"),
						I = [];
					for (
						Q && (P = P.split("++").join("")),
							p = (h = _.getElementsByTagName("*")).length,
							c = [],
							d = 0;
						d < p;
						d++
					)
						c[d] = h[d];
					if (q || F)
						for (d = 0; d < p; d++)
							((C = (u = c[d]).parentNode === _) || F || (D && !z)) &&
								((T = u.offsetTop),
								q &&
									C &&
									Math.abs(T - A) > W &&
									("BR" !== u.nodeName || 0 === d) &&
									((g = []), q.push(g), (A = T)),
								F &&
									((u._x = u.offsetLeft),
									(u._y = T),
									(u._w = u.offsetWidth),
									(u._h = u.offsetHeight)),
								q &&
									(((u._isSplit && C) ||
										(!D && C) ||
										(z && C) ||
										(!z &&
											u.parentNode.parentNode === _ &&
											!u.parentNode._isSplit)) &&
										(g.push(u), (u._x -= w), l(u, _, j) && (u._wordEnd = !0)),
									"BR" === u.nodeName &&
										((u.nextSibling && "BR" === u.nextSibling.nodeName) ||
											0 === d) &&
										q.push([])));
					for (d = 0; d < p; d++)
						(C = (u = c[d]).parentNode === _),
							"BR" !== u.nodeName
								? (F &&
										((y = u.style),
										z ||
											C ||
											((u._x += u.parentNode._x), (u._y += u.parentNode._y)),
										(y.left = u._x + "px"),
										(y.top = u._y + "px"),
										(y.position = "absolute"),
										(y.display = "block"),
										(y.width = u._w + 1 + "px"),
										(y.height = u._h + "px")),
								  !z && D
										? u._isSplit
											? ((u._next = u.nextSibling), u.parentNode.appendChild(u))
											: u.parentNode._isSplit
											? ((u._parent = u.parentNode),
											  !u.previousSibling &&
													u.firstChild &&
													(u.firstChild._isFirst = !0),
											  u.nextSibling &&
													" " === u.nextSibling.textContent &&
													!u.nextSibling.nextSibling &&
													I.push(u.nextSibling),
											  (u._next =
													u.nextSibling && u.nextSibling._isFirst
														? null
														: u.nextSibling),
											  u.parentNode.removeChild(u),
											  c.splice(d--, 1),
											  p--)
											: C ||
											  ((T = !u.nextSibling && l(u.parentNode, _, j)),
											  u.parentNode._parent &&
													u.parentNode._parent.appendChild(u),
											  T && u.parentNode.appendChild(f.createTextNode(" ")),
											  "span" === M && (u.style.display = "inline"),
											  E.push(u))
										: u.parentNode._isSplit && !u._isSplit && "" !== u.innerHTML
										? k.push(u)
										: D &&
										  !u._isSplit &&
										  ("span" === M && (u.style.display = "inline"), E.push(u)))
								: q || F
								? (u.parentNode && u.parentNode.removeChild(u),
								  c.splice(d--, 1),
								  p--)
								: z || _.appendChild(u);
					for (d = I.length; -1 < --d; ) I[d].parentNode.removeChild(I[d]);
					if (q) {
						for (
							F &&
								((S = f.createElement(M)),
								_.appendChild(S),
								(b = S.offsetWidth + "px"),
								(T = S.offsetParent === _ ? 0 : _.offsetLeft),
								_.removeChild(S)),
								y = _.style.cssText,
								_.style.cssText = "display:none;";
							_.firstChild;

						)
							_.removeChild(_.firstChild);
						for (
							x = " " === j && (!F || (!z && !D)), d = 0;
							d < q.length;
							d++
						) {
							for (
								g = q[d],
									(S = f.createElement(M)).style.cssText =
										"display:block;text-align:" +
										H +
										";position:" +
										(F ? "absolute;" : "relative;"),
									P && (S.className = P + (Q ? d + 1 : "")),
									R.push(S),
									p = g.length,
									h = 0;
								h < p;
								h++
							)
								"BR" !== g[h].nodeName &&
									((u = g[h]),
									S.appendChild(u),
									x && u._wordEnd && S.appendChild(f.createTextNode(" ")),
									F &&
										(0 === h &&
											((S.style.top = u._y + "px"),
											(S.style.left = w + T + "px")),
										(u.style.top = "0px"),
										T && (u.style.left = u._x - T + "px")));
							0 === p
								? (S.innerHTML = "&nbsp;")
								: z || D || (v(S), m(S, "\xa0", " ")),
								F && ((S.style.width = b), (S.style.height = u._h + "px")),
								_.appendChild(S);
						}
						_.style.cssText = y;
					}
					F &&
						(a > _.clientHeight &&
							((_.style.height = a - O + "px"),
							_.clientHeight < a && (_.style.height = a + L + "px")),
						s > _.clientWidth &&
							((_.style.width = s - V + "px"),
							_.clientWidth < s && (_.style.width = s + B + "px"))),
						o(i, E),
						z && o(n, k),
						o(r, R);
				})(n, _, this.chars, this.words, this.lines, i, $);
		return (
			this.chars.reverse(),
			this.words.reverse(),
			this.lines.reverse(),
			(this.isSplit = !0),
			this
		);
	}),
		(b.revert = function () {
			if (!this._originals) throw "revert() call wasn't scoped properly.";
			for (var _ = this._originals.length; -1 < --_; )
				this.elements[_].innerHTML = this._originals[_];
			return (
				(this.chars = []),
				(this.words = []),
				(this.lines = []),
				(this.isSplit = !1),
				this
			);
		}),
		(y.selector =
			_.$ ||
			_.jQuery ||
			function (e) {
				var t = _.$ || _.jQuery;
				return t
					? (y.selector = t)(e)
					: "undefined" == typeof document
					? e
					: document.querySelectorAll
					? document.querySelectorAll(e)
					: document.getElementById("#" === e.charAt(0) ? e.substr(1) : e);
			}),
		(y.version = "0.7.0");
})(_gsScope),
	(function () {
		"use strict";
		function _() {
			return (_gsScope.GreenSockGlobals || _gsScope).SplitText;
		}
		"undefined" != typeof module && module.exports
			? (module.exports = _())
			: "function" == typeof define && define.amd && define([], _);
	})();

// gsap.registerPlugin(ScrollTrigger, SplitText);

export default class SplitTextEffect {
	constructor(element) {
		if (!element) return;

		this.el = element;

		this.init();
	}

	init() {
		let tl = gsap.timeline();
		let splitText = new SplitText(this.el, {
			type: "lines,words,chars",
			linesClass: "split-line",
			wordsClass: "split-word",
			charsClass: "split-char",
		});

		let chars = splitText.chars;

		gsap.from(chars, {
			scrollTrigger: {
				trigger: this.el,
				once: !0,
				toggleActions: "play none none none",
				start: "top bottom",
			},
			opacity: 1,
			duration: 0.6,
			ease: "circ.out",
			y: 450,
			stagger: 0.08,
		});

		// console.log(chars);
		// let lines = this.el.innerText.trim().split("|");

		// this.el.replaceChildren();

		// lines.map((lineText) => {
		// 	let chars = lineText.trim().split("");

		// 	const line = document.createElement("div");
		// 	line.classList.add("line");
		// 	line.classList.add("overflow-y-hidden");

		// 	chars.forEach((ch) => {
		// 		const c = document.createElement("span");
		// 		c.classList.add("split-char");
		// 		c.classList.add("inline-block");
		// 		c.innerHTML = ch !== " " ? ch : "&nbsp;";
		// 		line.appendChild(c);
		// 	});

		// 	this.el.appendChild(line);
		// });

		// gsap.from(this.el.querySelectorAll(".split-char"), {
		// 	y: 450,
		// 	stagger: 0.08,
		// 	ease: "circ.out",
		// 	opacity: 1,
		// 	duration: 0.6,
		// 	scrollTrigger: {
		// 		trigger: this.el,
		// 		start: "top bottom",
		// 		// markers: true,
		// 		toggleActions: "play none none none",
		// 	},
		// });
	}
}
